import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {getDistricts, getFacility} from "../../api/apiClient";

const ComboOgdpDetail = ({
                           propLabel = '소속 상세',
                           propFilter = null,
                           propValue,
                           propOnChange,
                         }) => {

  /* 자치구 목록 data */
  const [stDistrictList, setDistrictList] = useState([]);

  /* 자치구 목록 갱신 */
  const updateDistrictList = () => {
    getDistricts()
        .then((res) => {
              // console.log(res.data.data.list);
              setDistrictList(res.data.data.list);
            }
        );
  };

  /* 시설 목록 data */
  const [stFcltyList, setFcltyList] = useState([]);

  /* 시설 목록 갱신 */
  const updateFcltyList = () => {
    getFacility('')
        .then((res) => {
              // console.log(res.data.data.list);
              setFcltyList(res.data.data.list);
            }
        );
  };


  useEffect(() => {
      console.log(`filter change: ${propFilter} `);
    updateFcltyList();
    updateDistrictList();
  }, []);

  return (
      <Form.Group as={Row} controlId='ogdpTy'>
        <Form.Label column md={3} className={'label text-end'}>
          {propLabel}
        </Form.Label>
        <Col md={9}>
          <Form.Select
              className={"input input-select"}
              onChange={propOnChange}
              defaultValue={propValue}
              key={propValue}
          >
            <option value={""}>{propFilter == 1 || propFilter == 3 ? '선택' : '해당없음'}</option>
            {Array.isArray(stFcltyList) && propFilter == 1 ?
                (stFcltyList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) :
                Array.isArray(stDistrictList) && propFilter == 3 ?
                    (stDistrictList.map((elem, idx) => {
                      return (
                          <option key={idx} value={elem.cd}>{elem.nm}</option>
                      )
                    })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
};

export default ComboOgdpDetail;